import { render, staticRenderFns } from "./userInvoices.vue?vue&type=template&id=ee8808d8&scoped=true&"
import script from "./userInvoices.vue?vue&type=script&lang=js&"
export * from "./userInvoices.vue?vue&type=script&lang=js&"
import style0 from "./userInvoices.vue?vue&type=style&index=0&id=ee8808d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8808d8",
  null
  
)

export default component.exports